import { createRequest } from "helpers/tools";

export const getMicrosoftBingURL = async () => {
    return await createRequest({
        suffix: `destinations/microsoft-bing/auth-url`,
        handleError: true,
        method: "get",
    });
};

export const postAuthorizeMicrosoftBing = async (payload) => {
    return await createRequest({
        suffix: `destinations/microsoft-bing/authorize`,
        handleError: true,
        method: "post",
        payload,
    });
};

export const postSaveMicrosoftBing = async (payload) => {
    return await createRequest({
        suffix: `destinations/microsoft-bing/save`,
        handleError: true,
        method: "post",
        payload,
    });
};

export const getMicrosoftBingConversions = async (destinationId) => {
    return await createRequest({
        suffix: `destinations/microsoft-bing/${destinationId}/conversions`,
        handleError: true,
        method: "get",
    });
};

export const getMicrosoftBingMappings = async (destinationId) => {
    return await createRequest({
        suffix: `destinations/microsoft-bing/${destinationId}/mappings`,
        handleError: true,
        method: "get",
    });
};

export const postMicrosoftBingMappings = async (destinationId, payload) => {
    return await createRequest({
        suffix: `destinations/microsoft-bing/${destinationId}/mappings`,
        handleError: true,
        method: "post",
        payload,
    });
};
